"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SongwriterCatalogHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "Your catalog shows songs associated with your writer name(s)."),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null,
        "Click on a work to view details, or click the ",
        react_1.default.createElement("strong", null, "Export"),
        " button to export your catalog with work details.")));
exports.default = SongwriterCatalogHeader;
